/* import __COLOCATED_TEMPLATE__ from './paywalled-space.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();